import React from 'react';
import get from 'lodash/get';
import { NextPage } from 'next';
import { useRouter } from 'next/router';
import _getId from '@helpers/get-id-from-slug';

import { MainLayout } from '@views/layouts';
import Breadcrumb from '@views/modules/product/sub-modules/breadcrumb';
import Banner from '@views/modules/product/sub-modules/banner/dynamic';
import Product from '@views/modules/product';
import ProductPlaceholder from '@views/components/product/ProductPlaceholder';
import Error from '@views/modules/error';
import TrackingFetcher from '@views/modules/recent-view/components/tracking-component';
import { useProductWithReviewQuery } from 'src/generated/graphql';

export const ProductPage: NextPage = (): JSX.Element => {
  const { query } = useRouter();
  const productId = _getId(query.slug);

  const { data, loading, error } = useProductWithReviewQuery({
    variables: { id: productId, limit: 12, offset: 0 },
  });
  const status = get(data, 'data.product.status');
  const isError = error || status !== 1;

  return (
    <MainLayout
      title="Sản phẩm"
      breadcrumb={
        <Breadcrumb loading={loading} error={error} data={get(data, 'data')} />
      }
      afterBody={<Banner />}
    >
      {loading ? (
        <ProductPlaceholder />
      ) : (
        <>
          {isError ? (
            <Error statusCode={404} />
          ) : (
            <>
              <TrackingFetcher productId={productId} />
              <Product data={get(data, 'data')} />
            </>
          )}
        </>
      )}
    </MainLayout>
  );
};

export default ProductPage;
